import { useNavigate } from "react-router-dom"
import { SquaredTickIcon } from "../../ui/icons/SquaredTickIcon"
import { formatterDate, GGNotificationTypeOptions, GGStandardOptionOptions, GGStandardOptions, GGStandardSubfieldOptions, GGValutationResultOptions, optionsFormatter } from "../../utils"
import { GetAllGGNotifications, resetGGNotificationCreationStatus, setGGNotificationIdToUpdate, setGGNotificationUpdateRequest } from "./globalGap/dataservice/slice"
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks"
import { GGNotificationDTO } from "./globalGap/dataservice/dto"
import { useEffect, useState } from "react"
import Button from "../../ui/molecules/button"
import { PopupForm } from "../../ui/organisms/popupForm"
import { GlobalGapNotificationAddPopup } from "./globalGap/datiGenerali/popup"

export function NotifyGlobalGapList() {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const [showAddPopup, setShowAddPopup] = useState<boolean>(false)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const ggNotificationState = useAppSelector(state => state.ggNotification)
    const navigate = useNavigate()

    const onEditHandle = (n: GGNotificationDTO) => {
        dispatch(setGGNotificationIdToUpdate(n.id))
        dispatch(setGGNotificationUpdateRequest({
            entryProtocolId: n.entryProtocolId !== null ? n.entryProtocolId : undefined,
            type: n.type,
            otherType: n.otherType,
            standard: n.standard,
            standardSubfield: n.standardSubfield,
            standardOption: n.standardOption,
            graspModule: n.graspModule,
            coopModule: n.coopModule,
            springModule: n.springModule,
            valutationDate: n.valutationDate,
            valutationResult: n.valutationResult,
            valutationNote: n.valutationNote,
            manipulationSoldProducts: n.manipulationSoldProducts,
            manipulationPostHarvesting: n.manipulationPostHarvesting,
            manipualtionInnerStructures: n.manipualtionInnerStructures,
            manipulationOtherStructuresNoGG: n.manipulationOtherStructuresNoGG,
            manipulationOtherStructuresGGWithGGN: n.manipulationOtherStructuresGGWithGGN,
            manipulationExtraFarmProducts: n.manipulationExtraFarmProducts
        }))
        navigate('/notifyGlobalGapEdit')
    }

    useEffect(() => {
        dispatch(GetAllGGNotifications({
            itemsPerPage: 0,
            page: 0,
            customerId: sessionState.selected.customerId!
        }))
    }, [])

    useEffect(() => {
        if (ggNotificationState.ggNotificationCreationStatus === 'successfully') {
            dispatch(resetGGNotificationCreationStatus())
            setShowSuccess(true)
            dispatch(GetAllGGNotifications({
                itemsPerPage: 0,
                page: 0,
                customerId: sessionState.selected.customerId!
            }))
        }
    }, [ggNotificationState.ggNotificationCreationStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <div>
            {
                (showSuccess) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div style={{ padding: '24px' }}>
                <table id="users-table" className="w-[100%]">
                    <thead className="h-[52px] uppercase">
                        <tr>
                            <th style={{ borderTopLeftRadius: '8px' }}></th>
                            <th className="width-[130px]">Data Invio</th>
                            <th className="width-[130px]">Protocollo</th>
                            <th className="width-[100px]">Tipologia</th>
                            <th className="width-[130px]">Tipologia Altro</th>
                            <th className="width-[20%]">Standard</th>
                            <th className="width-[130px]">Standard Sottocampo</th>
                            <th className="width-[130px]">Standard Opzione</th>
                            <th className="width-[130px]">Modulo GRASP</th>
                            <th className="width-[130px]">Modulo COOP Italia</th>
                            <th className="width-[130px]">Modulo SPRING</th>
                            <th className="width-[130px]">Data Valutazione</th>
                            <th className="width-[130px]">Valutazione Funzionario</th>
                            <th className="width-[130px]">Note</th>
                            <th style={{ borderTopRightRadius: '8px', width: '40px' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            ggNotificationState.getAllGGNotificationResponse?.data.map((notify, index) =>
                                <tr
                                    key={index}
                                    style={{
                                        color: '#4D797F',
                                        background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                    }}
                                >
                                    <td>
                                        <div style={{ display: 'flex', gap: '6px' }}>
                                            <button onClick={() => onEditHandle(notify)}>
                                                <SquaredTickIcon />
                                            </button>
                                        </div>
                                    </td>
                                    <td>{formatterDate(notify.createdAt!)}</td>
                                    <td>{notify.entryProtocolInfo}</td>
                                    <td>{optionsFormatter(notify.type, GGNotificationTypeOptions)}</td>
                                    <td>{notify.otherType}</td>
                                    <td>{optionsFormatter(notify.standard, GGStandardOptions)}</td>
                                    <td>{optionsFormatter(notify.standardSubfield, GGStandardSubfieldOptions)}</td>
                                    <td>{optionsFormatter(notify.standardOption, GGStandardOptionOptions)}</td>
                                    <td>{notify.graspModule ? 'Sì' : 'No'}</td>
                                    <td>{notify.coopModule ? 'Sì' : 'No'}</td>
                                    <td>{notify.springModule ? 'Sì' : 'No'}</td>
                                    <td>{formatterDate(notify.valutationDate)}</td>
                                    <td>{optionsFormatter(notify.valutationResult, GGValutationResultOptions)}</td>
                                    <td>{notify.valutationNote}</td>
                                    <td></td>
                                </tr>
                            )}
                    </tbody>
                </table>
                <div className="mt-5" style={{ display: 'flex', justifyContent: 'flex-end', gap: '24px' }}>
                    <Button
                        variant="outline"
                        color="dimgrey"
                        size="md"
                        iconPosition="off"
                        label="Aggiungi"
                        onClick={() => setShowAddPopup(true)}
                    />
                </div>
                {
                    showAddPopup &&
                    <PopupForm title={`Aggiungi domanda`} headerGreen close={() => setShowAddPopup(false)}>
                        <GlobalGapNotificationAddPopup close={() => setShowAddPopup(false)}></GlobalGapNotificationAddPopup>
                    </PopupForm>
                }
            </div>
        </div>
    )
}